export default {"src":"/_next/static/media/pharmacy-order-two.c98d77c8.svg","height":259,"width":280,"blurWidth":0,"blurHeight":0};